import * as angular from 'angular';

"use strict";
angular.module('EnterDataCtrl', ['AuthService', 'UserService']);

export default 'EnterDataCtrl'
